import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { PackageSearch, ArrowDownToLine, ArrowUpFromLine, AlertTriangle, ArrowRightLeft, DollarSign } from 'lucide-react';

export function InventoryKpiDashboard() {
  const inventoryKpis: KpiItem[] = [
    {
      title: 'Tổng Giá Trị Tồn',
      value: '4.2',
      suffix: 'Tỷ',
      icon: DollarSign,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-emerald-500',
      chartData: [3.8, 3.9, 4.0, 4.1, 4.1, 4.2, 4.2]
    },
    {
      title: 'Mã Hàng Quản Lý',
      value: 1250,
      suffix: 'Mã',
      icon: PackageSearch,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Đồng bộ',
      chartColor: 'bg-blue-500',
      chartData: [1000, 1100, 1050, 1200, 1150, 1250, 1250]
    },
    {
      title: 'Cảnh Báo Thiếu',
      value: 15,
      suffix: 'Mặt hàng',
      icon: AlertTriangle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'down',
      trendValue: 'Cần nhập',
      chartColor: 'bg-red-500',
      chartData: [20, 18, 17, 16, 16, 15, 15]
    },
    {
      title: 'Phiếu Nhập Chờ',
      value: 8,
      suffix: 'Phiếu',
      icon: ArrowDownToLine,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Đang giao',
      chartColor: 'bg-indigo-500',
      chartData: [2, 4, 3, 5, 6, 8, 8]
    },
    {
      title: 'Phiếu Xuất Chờ',
      value: 12,
      suffix: 'Phiếu',
      icon: ArrowUpFromLine,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'neutral',
      trendValue: 'Đang xử lý',
      chartColor: 'bg-amber-500',
      chartData: [10, 12, 11, 12, 13, 12, 12]
    },
    {
      title: 'Luân Chuyển Kho',
      value: 5,
      suffix: 'Lệnh',
      icon: ArrowRightLeft,
      color: 'text-violet-600',
      bg: 'bg-violet-50',
      trend: 'up',
      trendValue: 'Trong ngày',
      chartColor: 'bg-violet-500',
      chartData: [1, 2, 3, 4, 4, 5, 5]
    }
  ];

  return <KpiGrid kpis={inventoryKpis} />;
}
